export const LOCAL_STORAGE_KEYS = {
  WISHLIST_GUEST_SHARE_KEY: 'WISHLIST_GUEST_SHARE_KEY',
  WISHLIST_USER_ID: 'WISHLIST_USER_ID',
};
